import { mapState, mapGetters, mapMutations } from 'vuex';
import router from '@/router';

export default {
  data: () => {
    return {
      formModel: {},
      tabHash: '',
    };
  },

  computed: {
    ...mapState('admin', [
      'formChanged',
    ]),

    ...mapGetters([
      'buildSchema',
    ]),

    formOptions() {
      return Object.assign({ context: this }, this.$store.state.formOptions);
    },
  },

  methods: {
    ...mapMutations('admin', [
      'setFormChanged',
    ]),

    addForm(data, form, options = {}) {
      const parentId = this[`active${this.formParent}`].id;
      this.$store.dispatch(`admin/add${this.formName}`, { data, parentId, form }).then(() => {
        if (!options.noRedirect) {
          router.push({ name: this.formIndex });
        }
      }).catch(() => window.location.hash = options.tabHash);
    },

    handleTabChange(event) {
      if (!this.tabHash) {
        this.tabHash = event.tab.hash;
      }
      const form = event.tab.$children[0];
      // eslint-disable-next-line no-alert
      if (this.formChanged && confirm('You have unsaved changes. Would you like to save these?')) {
        this.addForm(this.formModel, form, { noRedirect: true, tabHash: this.tabHash });
      }
      this.setFormChanged(false);
      this.tabHash = event.tab.hash;
    },
  },
};
